import _extends from '../../../node_modules/@babel/runtime/helpers/extends.js';
import _defineProperty from '../../../node_modules/@babel/runtime/helpers/defineProperty.js';
import _objectWithoutProperties from '../../../node_modules/@babel/runtime/helpers/objectWithoutProperties.js';
import 'prop-types';
import { jsx } from '@emotion/core';
import logo from '../../styles/logo.js';
import { assetCDN } from '../../constants/assetCDN.json.js';
import { pascalCase } from '../../utils/stringUtils.js';
import { img } from '../../styles/elements/img.js';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function Logo(_ref) {
  var children = _ref.children,
      styleType = _ref.styleType,
      color = _ref.color,
      size = _ref.size,
      alt = _ref.alt,
      theme = _ref.theme,
      otherProps = _objectWithoutProperties(_ref, ["children", "styleType", "color", "size", "alt", "theme"]);

  var logoStyleProp = "dlsLogo".concat(pascalCase(styleType)).concat(pascalCase(size));

  var styleObject = _objectSpread(_objectSpread({}, logo[logoStyleProp]), theme);

  var url = "".concat(assetCDN, "/img/logos/dls-logo-").concat(styleType).concat(color && (styleType === 'line' || styleType === 'stack') ? "-".concat(color) : '', ".svg");

  var imgStyle = _objectSpread(_objectSpread({}, img), logo["".concat(logoStyleProp, "_img")]);

  return jsx("span", _extends({
    css: styleObject
  }, otherProps), children || jsx("img", {
    src: url,
    alt: alt,
    role: alt ? null : 'presentation',
    css: imgStyle
  }));
}

Logo.defaultProps = {
  children: '',
  styleType: 'line',
  color: '',
  size: 'md',
  alt: '',
  theme: undefined
};

export default Logo;
